// extracted by mini-css-extract-plugin
export default {"body-home":"body-register_body-home__Khdlx","button":"body-register_button__vxKtp","title-register":"body-register_title-register__7Dnuk"};